module.exports = __webpack_public_path__ + "img/complete.2c975ee7.svg";